<!-- Mapa ocupa todo el contenedor, filtros y detalle flotantes -->
<div class="map-fullscreen-wrapper" [class.panel-open]="detailPanelOpen">

  <!-- ── MAPA ─────────────────────────────────────────────────────────────── -->
  <div class="map-area">
    <agm-map
      [latitude]="mapLat"
      [longitude]="mapLng"
      [zoom]="mapZoom"
      [streetViewControl]="false"
      [fullscreenControl]="true"
      class="map-canvas">

      <agm-marker
        *ngFor="let report of reports"
        [latitude]="getMarkerLat(report)"
        [longitude]="getMarkerLng(report)"
        [iconUrl]="getMarkerIcon(report)"
        [title]="report.Subject"
        (markerClick)="onMarkerClick(report)">
      </agm-marker>

    </agm-map>

    <!-- Loader -->
    <div class="map-overlay-loader" *ngIf="isLoading">
      <div class="loader-card">
        <i class="fa fa-spinner fa-spin fa-2x text-primary mb-2"></i>
        <span class="text-muted small">Cargando reportes...</span>
      </div>
    </div>

    <!-- Sin datos -->
    <div class="map-overlay-empty" *ngIf="!isLoading && reports.length === 0">
      <div class="empty-card">
        <i class="fa fa-map-o fa-2x text-muted mb-2"></i>
        <p class="mb-0 text-muted small">Sin reportes en el período / filtros seleccionados.</p>
      </div>
    </div>

    <!-- ── PANEL FLOTANTE: FILTROS (izquierda) ─────────────────────────────── -->
    <div class="float-panel float-panel--left" [class.collapsed]="!filtersOpen">
      <div class="float-panel__header" (click)="toggleFilters()">
        <span class="float-panel__title">
          <i class="fa fa-sliders mr-1"></i> Filtros
          <span class="badge badge-primary ml-1" *ngIf="activeFiltersCount > 0">{{ activeFiltersCount }}</span>
        </span>
        <i class="fa float-panel__chevron"
          [class.fa-chevron-up]="filtersOpen"
          [class.fa-chevron-down]="!filtersOpen"></i>
      </div>

      <div class="float-panel__body" *ngIf="filtersOpen">
        <!-- Período -->
        <div class="filter-group">
          <label class="filter-label"><i class="fa fa-calendar mr-1"></i>Período</label>
          <input type="date" class="form-control form-control-sm mb-1" [(ngModel)]="startDate">
          <input type="date" class="form-control form-control-sm mb-1" [(ngModel)]="endDate">
          <button class="btn btn-primary btn-sm btn-block" (click)="loadReports()" [disabled]="isLoading">
            <i class="fa fa-refresh mr-1" [class.fa-spin]="isLoading"></i>
            {{ isLoading ? 'Cargando...' : 'Actualizar' }}
          </button>
        </div>

        <!-- Estado de atención -->
        <div class="filter-group">
          <label class="filter-label"><i class="fa fa-tag mr-1"></i>Estado de atención</label>
          <select class="form-control form-control-sm" [(ngModel)]="filterStatus" (change)="applyFilters()">
            <option value="">Todos los estados</option>
            <option *ngFor="let s of statusOptions" [value]="s">{{ s }}</option>
          </select>
        </div>

        <!-- Tipo de reporte -->
        <div class="filter-group">
          <label class="filter-label"><i class="fa fa-list mr-1"></i>Tipo de reporte</label>
          <select class="form-control form-control-sm" [(ngModel)]="filterSubject" (change)="applyFilters()">
            <option value="">Todos los tipos</option>
            <option *ngFor="let s of subjectOptions" [value]="s">{{ s }}</option>
          </select>
        </div>

        <!-- Acceso rápido -->
        <div class="filter-group">
          <label class="filter-label"><i class="fa fa-bolt mr-1"></i>Acceso rápido</label>
          <div class="custom-control custom-switch">
            <input type="checkbox" class="custom-control-input" id="switchQuickAccess"
              [(ngModel)]="filterQuickAccess" (change)="applyFilters()">
            <label class="custom-control-label" for="switchQuickAccess">Solo acceso rápido</label>
          </div>
        </div>

        <button class="btn btn-outline-secondary btn-sm btn-block mt-1"
          *ngIf="activeFiltersCount > 0" (click)="clearFilters()">
          <i class="fa fa-times mr-1"></i>Limpiar filtros
        </button>
      </div>
    </div>

    <!-- ── TARJETAS FLOTANTES: ESTADÍSTICAS (parte superior central) ─────────── -->
    <div class="stats-bar" *ngIf="!isLoading && reports.length > 0">

      <!-- Total -->
      <div class="stat-card stat-card--total">
        <div class="stat-card__value">{{ reports.length }}</div>
        <div class="stat-card__label">Total</div>
      </div>

      <!-- Por estado -->
      <div class="stat-card"
           *ngFor="let s of statusCounts"
           [style.--stat-color]="s.color"
           (click)="filterStatus = s.status; applyFilters()"
           [class.stat-card--active]="filterStatus === s.status"
           title="Filtrar por {{ s.status }}">
        <div class="stat-card__dot" [style.background]="s.color"></div>
        <div class="stat-card__value" [style.color]="s.color">{{ s.count }}</div>
        <div class="stat-card__label">{{ s.status }}</div>
      </div>

    </div>

    <!-- ── LEYENDA DE COLORES (esquina derecha superior) ──────────────────────── -->
    <div class="float-panel float-panel--right-top">
      <div class="float-panel__body">
        <div class="legend-row" *ngFor="let entry of legendEntries">
          <span class="legend-dot" [style.background]="entry.color"></span>
          <span>{{ entry.label }}</span>
        </div>
        <div class="legend-row legend-row--selected">
          <span class="legend-dot" style="background:#e91e8c"></span>
          <span>Seleccionado</span>
        </div>
      </div>
    </div>

  </div><!-- /map-area -->

  <!-- ── PANEL LATERAL DERECHO: DETALLE DEL REPORTE ──────────────────────── -->
  <div class="detail-panel" [class.open]="detailPanelOpen">

    <!-- Cabecera -->
    <div class="detail-panel__header">
      <h6 class="detail-panel__title mb-0">
        <i class="fa fa-file-text-o mr-2"></i>Detalle del reporte
      </h6>
      <div class="d-flex align-items-center">
        <button class="btn btn-outline-primary btn-sm mr-2" (click)="goToDetail()" *ngIf="detailReport">
          <i class="fa fa-external-link mr-1"></i>Abrir
        </button>
        <button class="btn btn-sm btn-link text-muted p-0" (click)="closeDetail()">
          <i class="fa fa-times fa-lg"></i>
        </button>
      </div>
    </div>

    <!-- Loader del detalle -->
    <div class="detail-loading" *ngIf="isLoadingDetail">
      <i class="fa fa-spinner fa-spin fa-2x text-primary"></i>
      <p class="mt-2 text-muted small">Cargando detalle...</p>
    </div>

    <!-- Contenido del detalle -->
    <div class="detail-panel__body" *ngIf="!isLoadingDetail && detailReport">

      <!-- Fotografía principal (ImgBase64 desde API o ImgUrl para compatibilidad) -->
      <div class="detail-photo" *ngIf="detailReport.ImgBase64 || detailReport.ImgUrl">
        <img [src]="detailReport.ImgBase64 || detailReport.ImgUrl" alt="Fotografía del reporte" class="detail-photo__img">
      </div>
      <div class="detail-photo detail-photo--empty" *ngIf="!detailReport.ImgBase64 && !detailReport.ImgUrl">
        <i class="fa fa-image fa-3x text-muted"></i>
        <span class="text-muted small mt-1">Sin fotografía</span>
      </div>

      <!-- Badges de estado y prioridad -->
      <div class="d-flex align-items-center flex-wrap px-3 pt-2 pb-1" style="gap:6px;">
        <span class="badge" [ngClass]="getStatusClass(detailReport.Status)">
          {{ detailReport.Status || 'Sin estado' }}
        </span>
        <span class="badge" [ngClass]="getPriorityClass(detailReport.Priority)">
          Prioridad: {{ detailReport.Priority || 'Baja' }}
        </span>
        <span class="badge badge-light ml-auto">
          <i class="fa fa-hashtag"></i> {{ detailReport.id }}
        </span>
      </div>

      <!-- Datos del reporte -->
      <div class="detail-section">
        <div class="detail-section__title">
          <i class="fa fa-info-circle mr-1"></i>Información del reporte
        </div>
        <table class="detail-table">
          <tbody>
            <tr>
              <td class="detail-table__label">Tipo</td>
              <td class="detail-table__value">{{ detailReport.Subject }}</td>
            </tr>
            <tr>
              <td class="detail-table__label">Fecha</td>
              <td class="detail-table__value">{{ formatDate(detailReport.created_at) }}</td>
            </tr>
            <tr>
              <td class="detail-table__label">Fuente</td>
              <td class="detail-table__value">{{ detailReport.Source || 'Invitado' }}</td>
            </tr>
            <tr *ngIf="detailReport.Department">
              <td class="detail-table__label">Área</td>
              <td class="detail-table__value">{{ detailReport.Department }}</td>
            </tr>
            <tr *ngIf="detailReport.Description">
              <td class="detail-table__label">Descripción</td>
              <td class="detail-table__value">{{ detailReport.Description }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Datos del ciudadano -->
      <div class="detail-section">
        <div class="detail-section__title">
          <i class="fa fa-user mr-1"></i>Ciudadano
        </div>
        <table class="detail-table">
          <tbody>
            <tr>
              <td class="detail-table__label">Nombre</td>
              <td class="detail-table__value">{{ detailReport.Name || 'Invitado' }}</td>
            </tr>
            <tr *ngIf="detailReport.PhoneNumber">
              <td class="detail-table__label">Teléfono</td>
              <td class="detail-table__value">{{ detailReport.PhoneNumber }}</td>
            </tr>
            <tr *ngIf="detailReport.Email">
              <td class="detail-table__label">Correo</td>
              <td class="detail-table__value">{{ detailReport.Email }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Ubicación -->
      <div class="detail-section" *ngIf="detailReport.Address">
        <div class="detail-section__title">
          <i class="fa fa-map-marker mr-1"></i>Ubicación
        </div>
        <p class="px-3 mb-0 small text-muted">
          <ng-container *ngIf="detailReport.Address.Street">{{ detailReport.Address.Street }}</ng-container>
          <ng-container *ngIf="detailReport.Address.ExtNumber"> #{{ detailReport.Address.ExtNumber }}</ng-container>
          <ng-container *ngIf="detailReport.Address.Neighborhood">, {{ detailReport.Address.Neighborhood }}</ng-container>
          <ng-container *ngIf="detailReport.Address.City">, {{ detailReport.Address.City }}</ng-container>
        </p>
      </div>

      <!-- Historial de atención -->
      <div class="detail-section">
        <div class="detail-section__title">
          <i class="fa fa-history mr-1"></i>Historial de atención
          <span class="badge badge-secondary ml-1">{{ detailReport.Event?.length || 0 }}</span>
        </div>

        <div class="timeline-empty px-3 pb-2" *ngIf="!detailReport.Event || detailReport.Event.length === 0">
          <i class="fa fa-clock-o mr-1 text-muted"></i>
          <span class="text-muted small">Sin eventos registrados</span>
        </div>

        <ul class="detail-timeline" *ngIf="detailReport.Event?.length > 0">
          <li class="detail-timeline__item" *ngFor="let event of detailReport.Event">
            <div class="detail-timeline__dot"></div>
            <div class="detail-timeline__content">
              <div class="d-flex align-items-center mb-1">
                <span class="detail-timeline__category">{{ event.EventCategory }}</span>
                <small class="text-muted ml-auto">{{ formatDate(event.created_at) }}</small>
              </div>
              <p class="detail-timeline__message">{{ event.Message }}</p>
              <small class="text-muted" *ngIf="event.User">
                <i class="fa fa-user-o mr-1"></i>{{ event.User.firstName }} {{ event.User.lastName }}
              </small>

              <!-- Imágenes del evento -->
              <div class="detail-timeline__images" *ngIf="event.ImgUrl?.length > 0">
                <ng-container *ngFor="let img of event.ImgUrl; let i = index">
                  <a [href]="img" target="_blank" *ngIf="isImage(event.fileTypes[i])">
                    <img [src]="img" alt="evidencia" class="detail-timeline__thumb">
                  </a>
                  <a [href]="img" target="_blank" *ngIf="!isImage(event.fileTypes[i])" class="detail-timeline__pdf">
                    <i class="fa fa-file-pdf-o fa-2x text-danger"></i>
                    <span class="small">PDF</span>
                  </a>
                </ng-container>
              </div>
            </div>
          </li>
        </ul>
      </div>

    </div><!-- /detail-panel__body -->

  </div><!-- /detail-panel -->

</div>
